module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img-2.b633b37e.jpeg";